import { post } from '../client/client';
import { endpoint } from '../endpoint';
import type { FileUploadResponse, ProfilePhotoUploadResponse } from '../type/upload';

const toFormData = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return formData;
};

const multipartConfig = { headers: { 'Content-Type': 'multipart/form-data' } };

export const uploadProfilePhoto = async (file: File) => {
  return await post<ProfilePhotoUploadResponse, FormData>(
    endpoint.uploadProfilePhoto,
    toFormData(file),
    multipartConfig
  );
};

export const uploadFile = async (file: File) => {
  return await post<FileUploadResponse, FormData>(endpoint.uploadFile, toFormData(file), multipartConfig);
};
